import React, {useState,useEffect} from 'react';
import { Link } from 'react-router-dom';
import Header from 'components/Headers/Header';
import {getCartEvents,checkoutAPI} from 'network/ApiAxiosTickets'
import { Button, Modal, ModalBody, ModalFooter, Input,FormGroup,Row,Col, Label } from "reactstrap";

import CartProducts from './CartProducts';
import axios from 'axios';

const EventsCart = () => {
    const [cartArray, setcartArray] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [total, setTotal] = useState(0);
    const [totalNow, setTotalNow] = useState(0);
    const [reload, setreload] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientEmail, setClientEmail] = useState("");
    const [loc, setLoc] = useState({});
    const [phone, setPhone] = useState('');
    const [phoneCountryCode, setPhoneCountryCode] = useState(31);
    const [disablePurchaseButton, setDisablePurchaseButton] = useState(false);
    const [notes, setNotes] = useState('');

    const reloadComponent = ()=>{
        setreload(!reload)
    }
    
    const cart = JSON.parse(localStorage.getItem('cart'))
    const role = JSON.parse(localStorage.getItem("user")).role
    
    useEffect(() => {
        checkCartItems()
        itemCounter()
        getLocation()
    }, [reload])

    const checkCartItems = ()=>{
        const cart = JSON.parse(localStorage.getItem('cart'))
        if(cart){
            setcartArray(cart)
            totalCalc(cart)
        }
    }
    const getLocation = () => {
        if (!navigator.geolocation) {
          alert('Geolocation is not supported by your browser(you wont be able to proced with the order)');
          setLoc(false)
        } else {
          navigator.geolocation.getCurrentPosition((position) => {
            setLoc({lat:position.coords.latitude,lng:position.coords.longitude})
          }, () => {
            alert('Unable to retrieve your location(you wont be able to proced with the order)');
            setLoc(false)
        });
        }
      }
      
    const handleCheckout = async()=>{
        setDisablePurchaseButton(true)
        const cart = JSON.parse(localStorage.getItem('cart'))
        const Seller = JSON.parse(localStorage.getItem("user"))._id;
        if(clientName!=""&&phone!=""){
            const checkStock = await axios.post('https://new.geticketsonline.com:9876/stripe/seller/checkout',{cart})
            if(checkStock.data.success){
                const response = await checkoutAPI(cart,clientName,clientEmail,total,totalNow,Seller,loc,phoneCountryCode + '' + phone,notes,JSON.parse(localStorage.getItem("user")))
                console.log(response.data.success)
                if(response.data.success){
                    setClientEmail("")
                    setClientName("")
                    setNotes('')
                    setModalOpen(!modalOpen)
                    clearCart() 
                    setDisablePurchaseButton(false)
                }else{
                    alert('Something went wrong please try again')
                }
            }else{
                alert('One of the events is out of stock')
                setClientEmail("")
                setClientName("")
                setModalOpen(!modalOpen)
                clearCart() 
                setDisablePurchaseButton(false)
            }
        }else{
            alert('Please fill all the fields')
            setDisablePurchaseButton(false)
        }
    }

    const clearCart = ()=>{
        localStorage.removeItem('cart')
        setreload(!reload)
    }

    const itemCounter = ()=>{
        const cart = JSON.parse(localStorage.getItem('cart'))
        if(cart){
            let count = 0;
            cart.map((item)=>{
                count = count + parseInt(item.qt)
            })
            setItemCount(count)
        }
    }

    const totalCalc =  (apiData)=>{
        const cart = JSON.parse(localStorage.getItem('cart'))
        let total = 0;
        //let totalNow = 0; 
        cart.map( (item)=>{
            let price =  item.price
            //let priceNow = apiData.find((prod)=> prod._id === item._id).Upfront
            total = total + (price * item.qt)
            //totalNow = total
        })
        setTotal(total)
        //setTotalNow(totalNow)
    }
    
    return ( 
        <>
            {role=="admin" && <Header/>}
            <Row>
               <Link to={"/" + role + "/events"} className="mt-6">
                <button type="button" className="btn btn-danger mb-2 mt-4 float-left">
                    Back to Events
                </button>
            </Link> 
            </Row>
            <div >
                
                <div className="text-center mt-5">
                    <h1>Cart</h1>
                </div>

                
                <div className="row no-gutters justify-content-center">
                    <div className="col-sm-9 p-3">
                        {
                            cart ?
                            <CartProducts cart={cartArray} refresh={reloadComponent} /> :
                            <div className="p-3 text-center text-muted">
                                Your cart is empty
                                <br></br>
                                
                            </div>
                        }
                        {cart && <Row className='ml-5 mt-2' >
                            <Label>Order Notes:
                            <Input type='textarea' value={notes} onChange={(e)=> setNotes(e.target.value)}/></Label>
                        </Row>}
                    </div>
                    {
                        cart ? 
                        <div className="col-sm-3 p-3">
                            <div className="card card-body">
                                <p className="mb-1">Total Items</p>
                                <h4 className=" mb-3 txt-right">{itemCount}</h4>
                                <p className="mb-1">Total Payment</p>
                                <h3 className="m-0 txt-right">{total}€</h3>
                                <hr className="my-4"/>
                                <div className="text-center">
                                    <button type="button" className="btn btn-primary mb-2" onClick={()=>setModalOpen(true)}>CHECKOUT</button>
                                    <button type="button" className="btn btn-outlineprimary btn-sm" onClick={clearCart}>CLEAR</button>
                                </div>

                            </div>
                        </div>
                        : null
                    }
                    
                </div>
                
                
                {/* new event modal */}
                <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}>
                    <div className=" modal-header">
                    <h5 className=" modal-title" id="exampleModalLabel">
                        Client Info
                    </h5>
                    </div>
                    <ModalBody className=" text-center">
                    <FormGroup>
                    <Input
                        className="form-control-alternative mb-3"
                        id="input-ClientName"             
                        placeholder="Client Name"             
                        onChange={(e)=>setClientName(e.target.value)}             
                        type="text"   
                         
                    /> 
                    <Input
                        className="form-control-alternative mb-3"
                        id="input-ClientEmail"             
                        placeholder="Client Email"             
                        onChange={(e)=>setClientEmail(e.target.value)}             
                        type="text"  
                        hidden  
                    /> 
                    <Row>
                        <Col sm='3' xs='3' md='3'>
                            <Input
                                className="form-control-alternative mb-3"
                                id="input-ClientPhoneIndicative"             
                                placeholder="Country Code"             
                                onChange={(e)=>setPhoneCountryCode(e.target.value)} 
                                value={phoneCountryCode}            
                                type="Number"    
                            /> 
                        </Col>
                        <Col sm='9' xs='9' md='9'>
                            <Input
                                className="form-control-alternative mb-3"
                                id="input-ClientPhone"             
                                placeholder="Client Phone"             
                                onChange={(e)=>setPhone(e.target.value)}             
                                type="Number"    
                            /> 
                        </Col>
                    </Row>
                    </FormGroup>               
                    </ModalBody>
                    <ModalFooter>
                        
                    <Button
                        color="secondary"
                        type="button"
                        onClick={() => setModalOpen(!modalOpen)}
                    >
                        Cancel
                    </Button>
                    <Button color="primary" type="button" onClick={handleCheckout} disabled={disablePurchaseButton}>
                        Purchase
                    </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>
     );
}
 
export default EventsCart;